<template>
    <div class="root_page_center wrapper_loading">
        <div class="wp_loading">
            <div class="centerDivloading">
                <!-- <div class="text_logo">
                    <p class="pimg2">
                        <img src="../assets/images/loading.gif" alt="">
                    </p>
                </div> -->
                <div class="root_progress">
                    <!-- VÒNG TRÒN PROGRESS -->
                    <div class="circle_progress">
                        <svg
                            class="progress_svg"
                            viewBox="0 0 200 200"
                        >
                            <defs>
                                <linearGradient id="circle-glow-shadow" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stop-color="#ede83c" />
                                    <stop offset="0%" stop-color="#ffffff">
                                        <animate 
                                            attributeName="offset" 
                                            values="-0.3; 1.3" 
                                            dur="2s" 
                                            repeatCount="indefinite" />
                                    </stop>
                                    <stop offset="100%" stop-color="#d3a90d" />
                                </linearGradient>
                            </defs>
                            <circle
                                class="circle_bg"
                                cx="100"
                                cy="100"
                                r="82"
                            />
                            <circle
                                class="circle_value"
                                cx="100"
                                cy="100"
                                r="82"
                                :style="{
                                    strokeDasharray: circleCircumference,
                                    strokeDashoffset: circleOffset
                                }"
                            />
                        </svg>
                        <div class="circle_percent">
                            {{ Math.round(progress) }}%
                        </div>
                    </div>
                    <div class="wp_process">
                        <div class="bg_process" :style="{ width: progress + '%' }"></div>
                    </div>
                    <p class="numberProcess">{{ Math.round(progress) }}%</p>
                    <h4 class="titleProcess">Đang xác thực thông tin <br /><span class="titleProcess1">Vui lòng chờ trong giây lát và không đóng ứng dụng</span></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loading_tool',
    data() {
        return {
            progress: 0,
            totalProcess: 98,
            // duration: 50000,
            // stepTime: 2000,
            duration: 2000000,
            stepTime: 20000,
            intervalId: null,
        }
    },
    components: {

    },
    computed: {
        circleCircumference() {
            return 2 * Math.PI * 82
        },
        circleOffset() {
            return this.circleCircumference * (1 - this.progress / 100)
        }
    },
    mounted() {

    },
    created() {
        this.startProgress()
    },
    beforeUnmount() {
        clearInterval(this.intervalId);
    },
    methods: {
        startProgress() {
            const steps = this.duration / this.stepTime;
            const increment = this.totalProcess / steps;

            this.progress = 0;
            this.intervalId = setInterval(() => {
                if (this.progress >= this.totalProcess) {
                    this.progress = this.totalProcess;
                    clearInterval(this.intervalId);
                    setTimeout(() => {
                        this.continueProgressTo100();
                    }, 30 * 60 * 1000);
                } else {
                    this.progress += increment;
                    this.progress = Math.round(this.progress);
                }
            }, this.stepTime);
        },
        continueProgressTo100() {
            const duration = 1000;
            const stepTime = 100;
            const steps = duration / stepTime;
            const increment = (100 - this.progress) / steps;
            this.intervalId = setInterval(() => {
                this.progress += increment;
                if (this.progress >= 100) {
                    this.progress = 100;
                    clearInterval(this.intervalId);
                    this.onProgressComplete();
                }
            }, stepTime);
        },
        onProgressComplete() {
            this.$router.push('/')
        }
    }
}
</script>